// extracted by css-extract-rspack-plugin
export default {"emptyContent":"emptyContent-jwaF1H"};